<div class="left-side">
  <ui-page-header>{{ bundleTemplate().name }}</ui-page-header>

  <ui-configurable-bundle-form-banner [bundleTemplate]="bundleTemplate()"></ui-configurable-bundle-form-banner>

  <div class="slot-list">
    @for (slot of bundleTemplate().slots; track slot.id) {
      @let slotState = bundleState().slotMap.get(slot.id);

      @if (slotState) {
        <ui-configurable-bundle-form-slot
          [disabled]="slot.slotType === 'free' && freeSlotDisabled()"
          [class.free-slot]="slot.slotType === 'free'"
          [slotThresholdReachedIndex]="slotThresholdReachedIndex()"
          [slot]="slot"
          [slotState]="slotState"
          (slotStateChange)="onSlotUpdate($event)">

        </ui-configurable-bundle-form-slot>
      }
    }
  </div>
</div>

<ng-template #summaryContent let-initiallyExpanded="initiallyExpanded">
  @if (visibleSummarySections().includes('bundle-summary')) {
    <ui-configurable-bundle-form-summary
      [listExpanded]="initiallyExpanded"
      (addToCart)="onAddToCart()"
      [addToCartDisabled]="addToCartDisabled()"
      [isAddToCartLoading]="isAddToCartLoading()"
      [isInCart]="!!cartItem()"
      [bundleTemplate]="bundleTemplate()"
      [bundleState]="bundleState()"
      (bundleStateChange)="onBundleStateChange($event)"
    >
    </ui-configurable-bundle-form-summary>
  }

  @if (visibleSummarySections().includes('slot-step-summary')) {
    <ui-configurable-bundle-form-slots-info [bundleState]="bundleState()"></ui-configurable-bundle-form-slots-info>
  }
</ng-template>

<div class="right-side">
  <ng-container *ngTemplateOutlet="summaryContent;context: {initiallyExpanded: false}"></ng-container>
</div>

<ng-template autoFocusTarget="first-heading" width="100vw" #sideSheet="SideSheetDirective" uiSideSheetSide="right">
  <ui-side-sheet-header (closeSideSheet)="sideSheet.close()">
    @if (visibleSummarySections().includes('slot-step-summary')) {
      Paketübersicht
    } @else {
      Preisübersicht
    }
  </ui-side-sheet-header>
  <div class="wrapper-side-sheet-content" tabindex="0">

    <div class="content">
      <ng-container *ngTemplateOutlet="summaryContent;context: {initiallyExpanded: true}"></ng-container>
    </div>

    <hr>
    <div class="actions">
      @if (!cartItem()) {
        <ui-button [disabled]="addToCartDisabled() || isAddToCartLoading()" [loading]="isAddToCartLoading()" (clicked)="onAddToCart()">In den Warenkorb</ui-button>
      } @else {
        <ui-button buttonStyle="tonal" [disabled]="addToCartDisabled() || isAddToCartLoading()" [loading]="isAddToCartLoading()" (clicked)="onAddToCart()">Paketaktion anpassen</ui-button>
      }
    </div>
  </div>
</ng-template>

<ui-configurable-bundle-form-bottom-bar
  (close)="visibleSummarySections.set(['bundle-summary','slot-step-summary'])"
  [addToCartDisabled]="addToCartDisabled()"
  [isAddToCartLoading]="isAddToCartLoading()"
  (openSideSheet)="visibleSummarySections.set([$event]);sideSheet.open()"
  (addToCart)="onAddToCart()"
>
</ui-configurable-bundle-form-bottom-bar>
